import { action } from '../dispatchAction'
import ActionTypes from './types'

export const setVersion = (version: string) => async dispatch => {
  dispatch(action(ActionTypes.set_version, version))
}



// WEBPACK FOOTER //
// ./src/store/configs/actions.ts